import { horizontalScroll } from '../../js/front/components/horizontal-scroll';

/* global themeVars */

document.querySelectorAll( '.b-careers-listing' ).forEach( ( block ) => {

	const buttons = block.querySelectorAll( '.career-filter-button' );
	const listing = block.querySelector( '.b-careers-listing__list' );

	if( buttons ) {

		buttons.forEach( ( button ) => {

			button.addEventListener( 'click', ( e ) => {

				const termId = e.currentTarget.dataset.termId;

				buttons.forEach( ( btn ) => btn.classList.remove( 'current' ) );
				e.currentTarget.classList.add( 'current' );

				listing.classList.add( 'is-loading' );

				fetch( themeVars.ajaxUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: new URLSearchParams( {
						action: 'filter_careers_by_taxonomy',
						term_id: termId,
						lang: block.dataset.lang || 'en',
						security: themeVars.security,
					} ),
				} )
					.then( ( response ) => response.text() )
					.then( ( html ) => {

						listing.innerHTML = html;

					} )
					.catch( () => {

						listing.innerHTML = 'Error';

					} )
					.finally( () => {

						listing.classList.remove( 'is-loading' );

					} );

			} );

		} );

	}

	horizontalScroll( '.b-careers-listing__filters' );

} );
